<template>
    <twemoji-picker
        ref="picker"
        :emojiData="emojiDataAll"
        :emojiGroups="emojiGroups"
        :skinsSelection="false"
        :searchEmojisFeat="true"
        searchEmojiPlaceholder="Rechercher."
        searchEmojiNotFound="Emojis introuvables."
        isLoadingLabel="Chargement..."
        :pickerPaddingOffset="10"
        @emojiUnicodeAdded="$emit('input', $event)"
        :data-component-name="$options.name"
    >
        <template v-slot:twemoji-picker-button>
            <q-icon name="insert_emoticon" class="js-emojipicker" />
        </template>
    </twemoji-picker>
</template>

<script>
    //######## https://kevinfaguiar.github.io/vue-twemoji-picker/docs/twemoji-picker-api/#props
    import {TwemojiPicker} from '@kevinfaguiar/vue-twemoji-picker';
    import EmojiAllData from '@kevinfaguiar/vue-twemoji-picker/emoji-data/fr/emoji-all-groups.json';
    // import EmojiDataAnimalsNature from '@kevinfaguiar/vue-twemoji-picker/emoji-data/fr/emoji-group-animals-nature.json';
    // import EmojiDataFoodDrink from '@kevinfaguiar/vue-twemoji-picker/emoji-data/fr/emoji-group-food-drink.json';
    import EmojiGroups from '@kevinfaguiar/vue-twemoji-picker/emoji-data/emoji-groups.json';
    export default {
        name: 'EmojiPicker-OLD',
        components: {
            'twemoji-picker': TwemojiPicker
        },
        mounted(){
        },
        beforeDestroy() {
            // this.$eventBus.$off('body-clicked');
        },
        computed: {
            emojiDataAll() {
                return EmojiAllData;
            },
            emojiGroups() {
                return EmojiGroups;
            }
        }
    }
</script>

<style lang="scss">
    @import "@/scss/components/form/EmojiPicker.scss";
</style>
